module.exports = __webpack_public_path__ + "img/rider-panel-2.b62f8725.jpg";